import {
  Component,
  ElementRef,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
  ReactiveFormsModule,
} from '@angular/forms';
import {
  CustomValidator,
  matchingPasswords,
  passwordValidator,
} from 'src/app/_utlis/app-validators';
import { ToastService } from 'src/app/Shared/services/toast/toast.service';
import { ActivatedRoute, Router } from '@angular/router';
import { DefulatRouting } from 'src/app/_utlis/enums/defualt-routing.enum';
import { environment } from 'src/environments/environment';

// Removed: getCurrentLngData, getPageData - migrated to ngx-translate

import { Location } from '@angular/common';

import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { Navigation } from 'src/app/_utlis/navigateToLanding';
import { Breadcrumb } from 'src/app/Shared/_models/breadcrumb.model';
import { AnalyticsService } from 'src/app/Shared/_services/analytics/analytics.service';
import { BreadCrumbsComponent } from 'src/app/Shared/components/bread-crumbs/bread-crumbs.component';
import { AuthService } from 'src/app/Core/auth/services/auth/auth.service';
import { PasswordFormComponent } from '../../components/password-form/password-form.component';
@Component({
  selector: 'app-reset-password',
  standalone: true,
  templateUrl: './buyer-reset-password.component.html',
  styleUrls: ['./buyer-reset-password.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [
    ReactiveFormsModule,
    BreadCrumbsComponent,
    PasswordFormComponent,
    TranslatePipe,
  ],
})
export class BuyerResetPasswordComponent {
  formData!: FormGroup;
  code!: any;
  email?: string;
  submit_clicked = false;
  // defualtPath=DefulatRouting.DEFUALT;
  defualtPath = environment.wordpressUrl;
  urlFront!: string;
  userType!: string;
  breadcrumbItems: Breadcrumb[] = [];
  navTranslation!: any;

  constructor(
    private fb: FormBuilder,
    private authService: AuthService,
    private toastService: ToastService,
    private router: Router,
    private route: ActivatedRoute,
    private translate: TranslateService,
    private nav: Navigation,
    private _location: Location,
    private analyticsService: AnalyticsService
  ) {
    // this.route.
    this.route.queryParams.subscribe((params) => {
      // this.phone = +params['phone'];

      this.code = params['code'];
      this.email = params['email'];
      this.userType = params['UserType'];
      if (!this.code || !this.email || !this.userType) {
        if (this.userType == 'seller') {
          this.router.navigate(['/seller/auth']);
        } else if (this.userType == 'buyer') {
          this.router.navigate(['/buyer/auth']);
        } else {
          this.nav.NavigateToLanding();
        }
      }
    });
    this.initForm();
  }
  ngOnInit(): void {
    this.urlFront = environment.url_front;
  }
  initForm() {
    this.formData = this.fb.group(
      {
        password: new FormControl(
          '',
          Validators.compose([
            Validators.required,
            Validators.minLength(8),
            CustomValidator.patternValidator(/\d/, { hasNumber: true }),
            CustomValidator.patternValidator(/[a-zA-Z]/, { hasAlphabet: true }),
          ])
        ),
        password_confirmation: new FormControl(
          '',
          Validators.compose([Validators.required])
        ),
        accept_terms: new FormControl(true),
      },
      { validator: matchingPasswords('password', 'password_confirmation') }
    );
  }
  onPasswordFormChange(form: FormGroup): void {
    this.formData = form;
  }

  canSubmit(): boolean {
    return this.formData.valid && this.formData?.value.accept_terms;
  }
  onSubmit(formValues: any) {
    if (this.canSubmit()) {
      this.submit_clicked = true;
      let body = {
        ...formValues,
        email: this.email,
        code: this.code,
        user_type: this.userType,
      };
      delete body.accept_terms;
      this.authService.resetPassword(body).subscribe({
        next: (res) => {
          this.toastService.showSuccess(
            this.translate.instant(
              'reset_password.password_changed_successfully'
            )
          );
          // Track password reset completed
          const userType = res.data.is_seller ? 'seller' : 'buyer';
          // this.analyticsService.trackPasswordReset('completed', userType as 'buyer' | 'seller');
          if (res.data.is_seller) {
            this.router.navigate(['/seller/auth/login']);
          } else if (res.data.is_buyer) {
            this.router.navigate(['/buyer/auth/login']);
          } else {
            //
          }
          this.submit_clicked = false;
        },
        error: (error) => {
          this.submit_clicked = false;

          error.error.Error.map((err: string) => {
            this.toastService.showError(err);
          });
        },
      });
    }
  }
  back() {
    this._location.back();
  }
}
